import React, { useState, useEffect } from 'react';
import Topbar from '../../superadmin/Layouts/Topbar';
import '../../superadmin/styles/pages/dashboard.css';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, InputAdornment, Typography,
    Button,
    Tooltip
} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from '@mui/icons-material/Close';
// import FilterAltIcon from '@mui/icons-material/FilterAlt';
import view from '../../superadmin/assets/icons/view-icon.svg';
import edit from '../../superadmin/assets/icons/add-icon.svg';
import Addadmin from '../../superadmin/components/Add_admin';
import CircularProgress from '@mui/material/CircularProgress';
import instance from '../../utils/Api';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Statusadmin from '../../superadmin/components/Status_admin';
import { useGlobalContext } from '../../Contex'; // Adjust the path
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const Drivers = () => {
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { openStatusDialog, setOpenStatusDialog } = useGlobalContext();//status popup
    const { loading, setLoading } = useGlobalContext();  // State to handle loading
    const { anchorEl, setAnchorEl } = useGlobalContext();   //filter
    const { searchTerm, setSearchTerm } = useGlobalContext(); //search state
    const [page, setPage] = useState(0);
    const rowsPerPage = 10; // Fixed rows per page
    const startIndex = (page) * rowsPerPage;  // Calculate the start and end index for pagination
    const [admins, setAdmins] = useState([]);
    const [addadmins, setAddadmins] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState(null);  // To store the selected admin for editing
    const open = Boolean(anchorEl);
    const { adminId } = useParams();
    const navigate = useNavigate();

    //filter function open menu
    // const handleClick1 = (event) => {
    //   setAnchorEl(event.currentTarget);
    // };

    //filter function close menu
    // const handleClose1 = () => {
    //   setAnchorEl(null);
    // };

    // Handle search
    const filteredAdmins = admins.filter((admin) => {
        const searchTermLower = (searchTerm).toLowerCase(); // Ensure searchTerm is always a string
        return (
            admin?.email?.toLowerCase().includes(searchTermLower) ||
            admin?.name?.toLowerCase().includes(searchTermLower) ||
            admin?.surname?.toLowerCase().includes(searchTermLower)
        );
    });

    //handle change
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Adjust to be 1-based
    };

    // Data slicing based on current page and rowsPerPage
    const paginatedAdmins = filteredAdmins.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

    //fetch fetchAdmins
    const fetchDrivers = async (adminId) => {
        try {
            const response = await instance.get(`/Drivers/getDrivers?admin_id=${adminId}`);
            setAdmins(response.data.data);
        } catch (error) {
            console.error('Error fetching admins:', error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDrivers();
        setAddadmins(false) // Reset after fetching
        setLoading(true);
    }, [addadmins]);
    useEffect(() => {
        fetchDrivers(adminId);
    }, [adminId]);

    // Function to handle opening the popup for editing
    const handleEditClick = (admin) => {
        setSelectedAdmin(admin);  // Set the selected admin
        setOpenDialog(true);  // Open the popup
    };

    // Function to handle opening the popup for adding new admin
    const handleAddClick = () => {
        setSelectedAdmin(null);  // Clear selected admin (add new mode)
        setOpenDialog(true);  // Open the popup
    };

    //Function to handle opening the popup status 
    const handleStatusClick = (admin) => {
        setSelectedAdmin(admin);
        setOpenStatusDialog(true);
    };

    return (
        <React.Fragment>
            <Topbar />
            {loading ? (
                <div className="loading">
                    <CircularProgress />
                </div>
            ) : (<section className='main'>
                <div className='employees-text'>
                    <Typography variant='h5'>Waste Picker's List</Typography>
                    <Button variant="outlined" onClick={() => navigate(-1)}><ArrowBackIcon />Back</Button>
                </div>
                <div className='employees-main'>
                    <div className='employees-content'>
                        <div className='search-options'>
                            <TextField
                                placeholder='Search'
                                type='search'
                                variant="outlined"
                                value={searchTerm}
                                onChange={(e) => { setSearchTerm(e.target.value); setPage(0) }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </div>
                        <div className='pagination-options table-pagination'>
                            <div className='pagination-animation'></div>
                            <TablePagination
                                component="div"
                                count={filteredAdmins?.length}
                                rowsPerPage={rowsPerPage}
                                page={page} // Adjust to be 0-based for MUI TablePagination
                                onPageChange={handleChangePage}
                                rowsPerPageOptions={[]}
                                labelDisplayedRows={({ from, to, count }) => (
                                    `${from} to ${to} of ${count !== -1 ? count : `more than ${to}`}`
                                )}
                            />

                        </div>
                    </div>
                    <div className='employee-table'>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <div className='employee-name'>
                                                S.NO
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Name
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Email
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Mobile Number
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Gender
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className='employee-name' >
                                                Status
                                            </div>
                                        </TableCell>
                                        {/* <TableCell align='center'>
                                            <div className='employee-name' >
                                                Action
                                            </div>
                                        </TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedAdmins.length > 0 ? (
                                        paginatedAdmins.map((admin, index) => (
                                            <TableRow tabIndex={-1} key={admin._id}>
                                                <TableCell component="th" scope="row">{startIndex + index + 1}</TableCell>
                                                <TableCell align="left">{admin?.name}</TableCell>
                                                <TableCell align="left">{admin?.email}</TableCell>
                                                <TableCell align="left">{admin?.mobile_no}</TableCell>
                                                <TableCell align="left">{admin?.Gender}</TableCell>

                                                <TableCell align='left'><span onClick={() => handleStatusClick(admin)} style={{ backgroundColor: admin.status === true ? 'rgb(229, 252, 240)' : 'rgb(255, 232, 232)', color: admin.status === true ? 'rgb(0, 166, 81)' : 'rgb(235, 87, 87)', padding: "5px 7px", borderRadius: "3px", cursor: "pointer" }}><Tooltip title="Change Status" >{admin?.status === true ? "Active" : "Inactive"}</Tooltip> </span></TableCell>

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={12} align="center">
                                                <Typography>No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </section>
            )}
            <Statusadmin Driver={true} fetchDrivers={() => fetchDrivers(adminId)} open={openStatusDialog} admin={selectedAdmin} setAddadmins={setAddadmins} handleClose={() => setOpenStatusDialog(false)} />
        </React.Fragment>
    )
}

export default Drivers